import type { FaireProductEntity } from "../../entity_types/product";

export const p_dzqxhfwz6b: FaireProductEntity = {
  token: "p_dzqxhfwz6b",
  type: "product",
  name: "The Whole Shebang - Complete Facial and Body Care Set/Kit",
  brandToken: "b_fb37a3eb",
  brandName: "Good Medicine Beauty Lab",
  imageUrl:
    "https://cdn.faire.com/fastly/9bb2696718eeac4c1529ef83d72d4688bde76765000677a3a1bb34afb5096fb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ebfc5336efc48c140c7ddeffc2cb59030c51501cb4b60779c98e933202d0ea06/1549584491.jpg",
    "https://cdn.faire.com/fastly/0a0a1c6037f010d9a3b4932a87b01fc212b38edfa8546d48f3d121641365fb86.jpeg",
    "https://cdn.faire.com/fastly/5f7f48f50a3175dfbd54ee4170efcb960d82f2baa7aaaf7ee87344c99fb03b35.png",
  ],
  priceDollars: 64,
  description:
    "COMPLETE GOOD MEDICINE COLLECTION\nYes, these samples sizes are huge. And we love that. We think you will too. These mini sizes are filled to the brim with luscious earth medicine that will bring you weeks of enjoyment. It's important to us that you really get to know each product and find what works best for your skin.\n(sold as a whole and not individually)\n2 cleansers, 2 toners, 2 masks, face cream, eye cream, 2 serums, exfoliant, 3 body creams, 3 body oils, and hair oil.",
  tags: [],
  msrpDollars: 128,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:40.156Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
